<template>
  <div>
    <vx-card  v-can="'view-supplier-users'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Supplier Name</label>

          <vs-input type="search"  placeholder="Search.." v-model="filters['company_name']" class="mb-4 md:mb-0 w-full"/>
        </div>
      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                     color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SUPPLIER USERS">
          <template slot="actions" v-can="'create-edit-supplier-users'">
            <vs-button  @click="onClickCreateSupplierUser" class="mr-4" color="primary" type="filled">Create Supplier User</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table pagination v-can="'view-supplier-users'" max-items="10" :data="staff"  @sort="handleSort"   stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th>SUPPLIER USER NAME</vs-th>
                <vs-th>EMAIL</vs-th>
                <vs-th>NIMBLE USER ROLES</vs-th>
                <vs-th>SUPPLIER PORTAL ROLE</vs-th>
                <vs-th class="float-left">PORTAL STATUS</vs-th>
                <vs-th width="8%">SAGE</vs-th>
                <vs-td></vs-td>
                <vs-th v-can="'create-edit-supplier-users'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickViewSupplier(data[indextr].id)" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].first_name">
                    {{ data[indextr].title }} {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].types">
                    <span v-for="(type, index) in data[indextr].types" :key="index">
                      {{ type.name }}, 
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].role">
                    {{ data[indextr].role ? data[indextr].role.name : '' }}
                  </vs-td>

                  <vs-td :data="data[indextr].is_active">
                    <!--                    {{ data[indextr].is_active }}-->
                    <vs-chip transparent v-if="data[indextr].is_active"  color="primary">
                      activated
                    </vs-chip>
                    <vs-chip transparent v-if="!data[indextr].is_active"  color="danger">
                      de-activated
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <span v-if="data[indextr].sage_id" class="text-primary">
                      Ref: {{ data[indextr].sage_id }}
                    </span>
                  </vs-td>

                  <vs-td>
                    <span v-if="data[indextr].sage_id">
                      <vx-tooltip class="mr-2" :text="`Synchronise data with sage`" position="left">
                        <vs-button @click.stop="onClickUpdateSageContact(data[indextr])" size="small" 
                          color="primary" type="filled" icon-pack="feather" icon="icon-refresh-cw"/>
                      </vx-tooltip>
                    </span>
                    <span v-if="!data[indextr].sage_id && data[indextr].types.some(type => type.name === 'Accounts Payable') && sage_id">
                      <vx-tooltip class="mr-2" text="Create sage customer contact" position="left">
                        <vs-button @click.stop="onClickSageSyncContact(data[indextr])"
                                  size="small" color="danger" type="filled" icon-pack="feather" icon="icon-refresh-cw"/>
                      </vx-tooltip>
                    </span>
                  </vs-td>

                  <vs-td v-can="'create-edit-supplier-users'">
                    <div class="vx-row">
                      <vx-tooltip text="View" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickViewSupplier(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="!data[indextr].email_verified_at && is_supplier_activated === 1" text="Send welcome email" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickSendWelcomeEmail(data[indextr].email, 'de-activate')"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-inbox"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="!data[indextr].is_active" text="Activate user" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickChangeSupplierStatus(data[indextr].id, 'activate')"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="data[indextr].is_active" text="De-activate user" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickChangeSupplierStatus(data[indextr].id, 'de-activate')"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
<!--            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>-->

          </div>
        </vx-card>
      </div>
    </div>
    <create-supplier-user-pop-up ref="createSupplierUserPopUp"/>
    <update-supplier-user-pop-up ref="updateSupplierUser"/>

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const SupplierRepository = RepositoryFactory.get('supplier')
  import CreateSupplierUserPopUp from '@/components/popups/supplier-users/CreateSupplierUserPopUp'
  import UpdateSupplierUserPopUp from '@/components/popups/supplier-users/UpdateSupplierUserPopUp'
  import ErrorMessages from "@/mixins/ErrorMessages";
  import SuccessMessage from "@/mixins/SuccessMessage";
  import SageFactory from '@/mixins/SageFactory';
  import { updateSageSupplierContact } from '@/services/SageService'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        selected: [],
        updateStaffSelected: [],
        options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
        popupActive: false,
        createUserPopupActive: false,
        popUpTitle: '',
        editActive: false,
        edit: null,
        editProp: {},
        checkBox1: false,
        activeConfirm: false,
        staff: [],
        selectedStaff: {},
        createStaffForm: {},
        departments: [],
        users: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        supplierId: null
      }
    },
    components: {
      'v-select': vSelect,
      CreateSupplierUserPopUp,
      UpdateSupplierUserPopUp
    },
    props: {
      is_supplier_activated: {
        type: Number,
        default: 0
      },
      sage_id: {
        default: null
      }
    },
    mixins : [Filter, ErrorMessages, SuccessMessage, SageFactory],
    async mounted () {

      this.$refs.filterCard.isContentCollapsed = true
      this.$refs.filterCard.maxHeight = '1.5rem'
      this.supplierId = this.$route.params.id

      this.$vs.loading()
      this.fetchSupplierUsers()
      this.$vs.loading.close()

    },
    methods: {
      async refreshData () {
        this.fetchSupplierUsers()
      },

      async fetchSupplierUsers() {
        this.$vs.loading()
        const {data} = await SupplierRepository.getSupplierUsers(this.supplierId, this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },
      openConfirm () {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remove Confirm',
          text: 'Are you sure you want to permanently remove this organization?',
          accept: this.acceptAlert
        })
      },

      acceptAlert () {
        this.$vs.notify({
          color: 'danger',
          title: 'Deleted Organization',
          position:'top-right',
          text: 'The selected organization was successfully deleted'
        })
      },
      async onClickCreateSupplierUser () {
        await this.$refs.createSupplierUserPopUp.openPopup(this.supplierId)
      },
      async onClickViewSupplier(id) {
        await this.$refs.updateSupplierUser.openPopup(id)
      },
      async onClickChangeSupplierStatus(id, status) {
        try {
          await SupplierRepository.supplierUserStatusChange(id, status)
          await this.fetchSupplierUsers()
          this.showSuccessMessage('Supplier user status changed successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      async onClickSendWelcomeEmail(email) {
        try {
          await SupplierRepository.resendWelcomeEmail(email)
          this.showSuccessMessage('Welcome email sent successfully')
        } catch (error) {
          this.convertAndNotifyError(e)
        }
      },
      filterQueryUpdate (){
        this.fetchSupplierUsers()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSupplierUsers()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSupplierUsers()
        }

      },
      async onClickSageSyncContact(data) {
        await this.$vs.loading()
        try {
          await this.createSupplierSageContact(this.sage_id, data)
          await this.fetchSupplierUsers()
        } catch (error) {
          
        }
        this.$vs.loading.close()
      },
      async onClickUpdateSageContact(data) {
        await this.$vs.loading()
        try {
          await updateSageSupplierContact(this.sage_id, data)
        } catch (error) {
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close()
      }

    },
    watch : {
      page(){
        this.fetchSupplierUsers()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
